import PopUp from "Components/PopUp/PopUp";
import React from "react";
import danger from "../../Assets/Images/danger.svg";

function BreachPop({ open, setOpen, data }) {
  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title={"Disqualification Notice: Rule Breached"}
      width={"600px"}

    >
      <div className="flex flex-row gap-4 py-4 items-center justify-center">
        <img src={danger} alt="danger" />
        <div className="flex flex-col gap-1">
        <div className="font-N_Bold text-[20px] flex items-center gap-2">
            Rule(s) Breached:{" "}
            <span className="font-N_Roman text-[13px] text-primary">
              Challenge ID: CH#ID {`${data?.login}`}
            </span>
          </div>
          <div className="text-[15px] font-N_Roman opacity-[0.44]">
            {data?.reason} {" "} (
            {new Date(data?.date).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            })}
            )
          </div>
        </div>
      </div>
    </PopUp>
  );
}

export default BreachPop;
